// Premissas de usuário.
// Acessíveis para todos os usuários mas somente o `Suporte/Admin/Vendedor` poderá alterá-las
export class PremissasUsuario {
  // Alíquota de Imposto Referencial
  public aliquotaDeImpostoReferencial: number;
  // Prazo para atualização de dados do integrador na Receita
  public prazoAtualizacaoReceitaIntegrador: number;
  // Habilita a utilização do Repasse no Menu Avulso
  public buscarEnderecoSomentePorReceita: boolean;
  // Percentual do Frete do Serviço
  public percentualFreteServico: number;
  // Ordena os painéis da tela de montar kit por descrição (false) ou valor painel / potência painel (true)
  public ordenarPaineisMontarKitPorValorDivPotencia: boolean;
  // Alíquota de PIS/COFINS
  public aliquotaPisCofins: number;
  // Calcular o frete no final
  public calcularFreteNoFinal: boolean;
  // Atualiza dados do integrador junto a Receita Federal ao fazer orçamento/pedido
  public atualizaDadosReceitaIntegrador: boolean;
  // Habilita a validação de kit customizado na edição do pedido
  public validarKitCustomizadoEdicaoPedido: boolean;
  // Guarda a última ação realizada alterarCentrodeDistribuicaoEmMassa
  public alterarCentrodeDistribuicaoEmMassa: boolean;
  // Guarda log do usuário que fez a última ação de alterar o centro de distribuicao em massa
  public logCentroDistribuicao: string;
  // Habilita a validação de inversores híbridos no kit customizado
  public validarInversoresHibridos: boolean;
  // Exibe os valores dos itens já com desconto nos arquivos de proposta
  public exibirItensJaComDescontoNaProposta: boolean;
  // Travar se o kit customizado não estiver válido
  public travarValidarKitCustomizado: boolean;
  // Texto informativo de Prazo
  public textoInformativoPrazo: string;
  // Cor Texto informativo de Prazo
  public corTextoInformativoPrazo: string;
  // Percentual de Markup mínimo para liberar valor de serviço
  public percentualMarkupMinimo: number;
  // Limite de arredondamento em reais
  public limiteArredondamentoReais: number;
}
